export default __webpack_public_path__ + "static/media/hht1_ep01_timeline_q02_a.534f4db4.png";